const getUsersPrefix = (url: string) => `/api/users${url}`;
const getTasksPrefix = (url: string) => `/api/tasks${url}`;
const getCaldavPrefix = (url: string) => `/api/integrations/caldav${url}`;

export const apiUrls = {
  auth: {
    loginByToken: '/api/auth:loginByToken',
    startOAuthFlow: '/api/auth:startOAuthFlow',
    logout: '/api/auth:logout',
  },
  users: {
    me: '/api/v2/users/me',
    suggest: getUsersPrefix(':suggest'),
  },
  tasks: {
    createWorklog: (taskKey: string) => getTasksPrefix(`/${taskKey}/timelogs`),
  },
  draftTimelogs: {
    list: '/api/draftTimelogs',
    create: '/api/draftTimelogs',
    update: (id: string) => `/api/draftTimelogs/${id}`,
    delete: (id: string) => `/api/draftTimelogs/${id}`,
    publish: (id: string) => `/api/draftTimelogs/${id}/:publish`,
    publishBulk: '/api/draftTimelogs:publishBulk',
  },
  stopwatches: {
    list: '/api/stopwatches',
    create: '/api/stopwatches',
    update: (id: string) => `/api/stopwatches/${id}`,
    delete: (id: string) => `/api/stopwatches/${id}`,
    start: (id: string) => `/api/stopwatches/${id}/:start`,
    pause: (id: string) => `/api/stopwatches/${id}/:pause`,
    finish: (id: string) => `/api/stopwatches/${id}/:finish`,
  },
  queues: {
    suggest: '/api/queues:suggest',
  },
  integrations: {
    caldav: {
      status: getCaldavPrefix('/status'),
      config: getCaldavPrefix('/config'),
      calendars: getCaldavPrefix('/calendars'),
      syncCalendars: getCaldavPrefix('/calendars/sync'),
      syncEvents: getCaldavPrefix('/sync'),
      events: getCaldavPrefix('/events'),
      eventAttendees: (eventId: string) => getCaldavPrefix(`/events/${eventId}/attendees`),
    },
  },
};
